<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9jcEUM/tc-custom/9781597143387.jpg?1726519206050" alt="This image is the cover for the book De-Bug"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">De-Bug
      </h1>
      <p class="bookDescription body article font2">
        <b>Stories of the dot-com boom—from everyone but the techies. “A raw look into the lives of residents bearing the brunt of gentrification.” —<i>HuffPost</i></b><br/><br/> No shuttle buses here: <i>De-Bug</i>, a new collection of true stories from the social justice organization of the same name, shows a side of working in Silicon Valley that you won’t read about in the business section. As tech moguls land the cover of <i>Forbes</i>, the South Bay’s working class is making ends meet as metal scrappers, factory workers, club bouncers, hairstylists, rickshaw drivers, ice cream cart pushers. The stories in <i>De-Bug </i>are poignant, often very funny accounts of bootstrapping in the land of angel investors and thought leaders. A construction worker predicts which of his customers are about to strike it rich and which are on the edge of bankruptcy based on the states of their swimming pools. A “secondhand hustler” travels the garage sale-flea market circuit in search of treasures to resell online. A temp worker at a medical device manufacturer sells his blood, at the company’s request, to test the equipment. These storytellers are frank when discussing their own flaws, but are equally up-front about the rigged system in which they operate.<br/><br/> Disruptive in the truest sense of the word, <i>De-Bug</i> offers valuable insight into California’s latest boomtown.<br/><br/><b>“Silicon Valley’s less-noticed denizens show an unexpected knack for grace, wit, and survival.” —Kentaro Toyama, author of <i>Geek Heresy</i></b><br/><br/><b>“If you truly want to know Silicon Valley, in all of its complexity, then <i>De-Bug</i> is a must-read.” —Tomás Jiménez, associate professor of sociology, Stanford University</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Raj Jayadev, Jean Melesaine
      </h2>
      
      <p class="authorDescription body article">Raj Jayadev is the cofounder of Silicon Valley De-Bug. His community organizing and writings about Silicon Valley have been featured in <I>The New York Times</I>, the <I>San Francisco Chronicle</I>, a PBS-aired documentary, and media outlets across the country. For his work lifting up personal experiences to impact public discourse around social, economic, and political issues, Jayadev has received numerous awards, including the Ashoka Fellowship. He lives in San Jose, California, with his wife and son.<br/><br/>Jean Melesaine is a Samoan American documentary writer-photographer based out of Oakland, California. Working with Silicon Valley De-Bug for over ten years, she was taught conscious photography from community members as a teenager. Her parents are from the villages of Moamoa and Faleali’li in Western Samoa. Jean’s photography and writings have been featured in places such as the Oakland Museum of California, and have earned a number of awards including the Tautai Arts Trust, an international residency for artists and writers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Heyday Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7807e9c2